import Reveal from "reveal.js";
export function toggleSlideshowPause() {
    const elems = document.querySelectorAll(".animations-to-pause");
    const isPaused = Reveal.isPaused();
    Reveal.togglePause();
    for (let i = 0, l = elems.length; i < l; i++) {
        elems[i].style.animationPlayState = isPaused ? "running" : "paused";
    }
}
